import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import Can from '@shared/permissions/Can'
import ListPageHeader from '@shared/ListPageHeader'
import ProductsList from '@shared/products/ProductsList'

import { productService } from '@services/admin/productService'
import { brandService } from '@services/admin/brandService'

const AdminProductsList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useAdminNotification() as { addJob: (jobId: string, jobName: string) => void }
  const [importModalVisible, setImportModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.list']}
        actions={
          <>
            <Can requiredPermission="products:write">
              <Button
                icon={<UploadOutlined />}
                onClick={() => setImportModalVisible(true)}
              >
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="products:write">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => navigate('/products/new')}
              >
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <ProductsList
        role="admin"
        service={productService}
        brandService={brandService}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
    </div>
  )
}

export default AdminProductsList;
